import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PagerItem = ({active, children, onClick}) => (
    <li className={classNames('page-item', {active})}>
        <a className="page-link" onClick={onClick}>{children}</a>
    </li>
);

PagerItem.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};

export default PagerItem;
